<template>
  <div>
    <Topbar />
    <Sidebar />

    <div class="app-content content">
      <div class="content-wrapper">
        <div class="content-wrapper-before"></div>
        <div class="content-header row"></div>
        <router-view/>
      </div>
    </div>

    <footer class="footer footer-static footer-light navbar-border navbar-shadow">
      <div class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
        <span class="float-md-left d-block d-md-inline-block">2018  &copy; Copyright <a class="text-bold-800 grey darken-2" href="http://goldenspoon.co.za/" target="_blank">Golden Spoon</a></span>
      </div>
    </footer>
  </div>
</template>

<script>
import Sidebar from '@/components/navigation/Sidebar.vue'
import Topbar from '@/components/navigation/Topbar.vue'

export default {
  name: 'appLayout',
  components: {
    Sidebar,
    Topbar
  },
  mounted: function () {
    $('body').attr('class', 'vertical-layout 2-columns fixed-navbar menu-hide vertical-overlay-menu').attr('data-col', '2-columns')
  }
}
</script>
